





























import Vue from 'vue'
import { ShiftFilterScope } from '@/types/enums'

interface ComponentData {
  positions: any
  filterSearchStringDialog: string| null
  filterScopeDialog: ShiftFilterScope
}

export default Vue.extend({
  name: 'SearchFilterDialog',

  components: {},

  props: {
    show: {
      type: Boolean,
      default: false
    },
    isCapelo: Boolean,
    filterSearchString: String,
    filterScope: Number
  },

  data (): ComponentData {
    return {
      positions: {
        clientX: undefined,
        clientY: undefined,
        movementX: 0,
        movementY: 0
      },
      filterSearchStringDialog: null,
      filterScopeDialog: ShiftFilterScope.AllShifts
    }
  },

  watch: {
    filterSearchStringDialog (newVal: string | null): void {
      this.$emit('searchStringChange', newVal)
    }
  },

  computed: {
    getPosition (): Object {
      const top : number = 0
      const left : number = (window.innerWidth - 258) / 2
      return {top: `${top}px`, left: `${left}px`}
    },
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    dragMouseDown: function (event: any) {
      event.preventDefault()
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      document.onmousemove = this.elementDrag
      document.onmouseup = this.closeDragElement
    },

    elementDrag: function (event: any) {
      // @ts-ignore
      const container: HTMLElement = this.$refs['draggableContainer']
      event.preventDefault()

      this.positions.movementX = this.positions.clientX - event.clientX
      this.positions.movementY = this.positions.clientY - event.clientY
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY

      if((container.offsetTop - this.positions.movementY) > -64 && (container.offsetTop - this.positions.movementY + container.clientHeight + 64) < event.view.innerHeight) {
        container.style.top = (container.offsetTop - this.positions.movementY) + 'px'
      } else if ((container.offsetTop - this.positions.movementY) < -64) {
        container.style.top = -64 + 'px'
      } else if ((container.offsetTop - this.positions.movementY) + container.clientHeight + 64 > event.view.innerHeight) {
        container.style.top = (event.view.innerHeight - (container.clientHeight + 64)) + 'px'
      }

      if((container.offsetLeft - this.positions.movementX) > 0 && (container.offsetLeft - this.positions.movementX + container.clientWidth + 18) < event.view.innerWidth) {
        container.style.left = (container.offsetLeft - this.positions.movementX) + 'px'
      } else if((container.offsetLeft - this.positions.movementX) < 0) {
        container.style.left = 0 + 'px'
      } else if((container.offsetLeft - this.positions.movementX + container.clientWidth + 18) > event.view.innerWidth) {
        container.style.left = (event.view.innerWidth - container.clientWidth - 18) + 'px'
      }

      this.setSchedulerFilterPosition()
    },

    setSchedulerFilterPosition (): void {
      // @ts-ignore
      const container: HTMLElement = this.$refs['draggableContainer']
      if(container) {
        const schedulerFilterPosition: any = {
          top: container.style.top ? container.style.top.toString() : '0',
          left: container.style.left ? container.style.left.toString() : ((window.innerWidth - 258) / 2).toString()
        }
        localStorage.setItem("schedulerFilterPosition", JSON.stringify(schedulerFilterPosition))
      }
    },

    closeDragElement () {
      document.onmouseup = null
      document.onmousemove = null
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onFilterScopeChange (): void {
      this.$emit('filterScopeChange', this.filterScopeDialog)
    }

  },

  mounted (): void {
    if(localStorage.getItem("schedulerFilterPosition")) {
      const startPosition: any = JSON.parse(localStorage.getItem("schedulerFilterPosition")!)
      // @ts-ignore
      const container: HTMLElement = this.$refs['draggableContainer']
      if(container) {
        container.style.top = startPosition.top
        container.style.left = startPosition.left
      }
    }

    this.filterSearchStringDialog = this.filterSearchString
    this.filterScopeDialog = this.filterScope

    setTimeout(() => {
      const filterField: any = this.$refs['filterField']
      if (filterField) {
        filterField.focus()
      }
    })
  }
})
